
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
  import UIButton from "@/components/button/ui-button.vue";
  import FormTextarea from "../form/FormTextarea.vue";
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages"
  import UPDATE_CONTRACTOR_NOTE from "@/apollo/contractors/UpdateContractorNote.gql"

  @Component({
    components: {
      ModalFullScreen,
      UIButton,
      FormTextarea,
    },
  })
  export default class EditNotesModal extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: String, default: "" }) readonly note!: string;
    @Prop({ type: String, required: true}) readonly id!: string;
    @Prop({type: String, required: true }) readonly contractorId!: string;
 
    editContractorNote: string = this.note
    processing: boolean = false

    onModalClose(): void {
      this.$emit('close')
    }
    handleCancel(): void {
      this.$emit('close')
    }
    async onUpdate() : Promise<void> {

      const isNoteChanged = this.editContractorNote !== this.note
      if (!isNoteChanged) {
        this.$eventBus.emit(
          NOTIFICATION,
          Message.infoMessage("You have not changed anything in the note")
        );
        return;
      }
      try {
        this.processing = true;
        await this.$apollo.mutate({
          mutation: UPDATE_CONTRACTOR_NOTE,
          variables: {
            id : this.id,
            notes: this.editContractorNote
          }

        });
      this.$emit('edit')
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage("Note editted successfully")
      )

      } catch(err) {
        this.$eventBus.emit(
          NOTIFICATION,
          Message.errorMessage(err.message)
        );
      } finally {
        this.processing = false
        this.handleClose()
      }
    }

    handleClose(): void {
      this.editContractorNote = ""
      this.$emit("close")
    }
  }
 
